import Events from "actions/events";
import { setOriginUrls, UrlInfo } from 'actions/config';

let ReduxDispatcher=null
export default class BaseActionCreator {

	// creates a URL string given an origin and url (path & query string)
	createUrlWithOrigin(origin, url) {
	  return `${origin}/${url}`;
	}
	get(origin, url) {
		return this.makeServerCall('GET', this.createUrlWithOrigin(origin,url));
	}
	//why is it adding an extra /
	post(origin, url, data) {
		return this.makeServerCall('POST', this.createUrlWithOrigin(origin,url), data);
	}
	dispatch() {
	   BaseActionCreator.dispatchAction.apply(this,arguments)
	}
	static dispatchAction() {
	   if(ReduxDispatcher) {
	     ReduxDispatcher.dispatch.apply(null,arguments);
	   }
	}
	static setDispatcher(dispatcher) {
	   ReduxDispatcher=dispatcher;
	}
	makeServerCall(verb, url, data) {
			const _this = this;
	    if(!url) {
	      throw new Error("Url is required for web call.")
	    }
	    // var _this=this;
			let headers = {}
			if(verb === 'POST') headers = {"Content-Type": "application/json"}
			headers.userId = `${UrlInfo.userId}`;
			let params = {
	        method: verb,
					headers: headers,
	        credentials: "include"
    	};
			if(data !== null && typeof data !== "undefined") {
          params.body=JSON.stringify(data);
      }
	    return new Promise((resolve,reject) => {
	      fetch(url, params).then((response) => {
	        var processResponse=(rawText)=>{
	          let responseType=response.headers.get("Content-Type");
	          let jsonResponse=null
	          if(responseType==null) {
	            resolve(null,response);
	            return;
	          }
	          if(responseType.indexOf("application/json")>=0 || responseType.indexOf("application/javascript")>=0) {
	            jsonResponse=JSON.parse(rawText)
	          }
	          if(response.status>=200 && response.status<300) {
	            resolve(jsonResponse,response);
              _this.dispatch({
                type: Events.ErrorHandler.CLEAR_ERROR,
              })
	          } else {
							console.log('BASE ACTION CREATOR', this, rawText);
							_this.dispatch({
								type: Events.ErrorHandler.ERROR,
								data: jsonResponse ? jsonResponse.message : rawText
							})
	            reject({xhr: response,data: jsonResponse, rawData: rawText,status: response.status,detail: response.statusText, url: url});
	          }
	        }
	        response.text().then(processResponse);

	      })
	    })

	}
}



// WEBPACK FOOTER //
// ./src/actions/BaseActionCreator.js